import { render, staticRenderFns } from "./TakeCustodyOption.vue?vue&type=template&id=f7231650&scoped=true&"
import script from "./TakeCustodyOption.vue?vue&type=script&lang=js&"
export * from "./TakeCustodyOption.vue?vue&type=script&lang=js&"
import style0 from "./TakeCustodyOption.vue?vue&type=style&index=0&id=f7231650&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7231650",
  null
  
)

export default component.exports